import $ from 'jquery';

// open and close news items
  $('.ncfp-news-item').click(function(){
    $(this).next().slideToggle(function() {
    });
    $(this).find(".play-toggle").toggleClass( "triangle-down", "play-toggle" );
  });

  $('#project-search-submit').click(function () {
    $(this).parents('form').submit();
  });
